// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"ece9872799c9441f1081","655":"4f87b096b4318ab30d75"}[chunkId] + ".js";
};